import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import Peer from 'peerjs'
import { Socket } from 'peerjs/lib/socket'
import { GameModule } from '@/store'
import { Player, MyDataConnection } from '@/index'
import router from '@/router'

const $peer = new Peer(undefined, {
  host: 'ing.rs',
  port: 3000,
  // path: 'assoc'
  secure: true,
  config: {
    iceServers: [
      { urls: 'stun:stun.ing.rs:5349' },
      { urls: 'turn:turn.ing.rs:5349', username: 'assoc', credential: 'x7aT7hHsGl2Mp8vq' }
    ]
  }
}) as Peer & {
  on(
    event: 'connection',
    cb: (conn: MyDataConnection) => void
  ): void;
  socket: Socket;
}

export interface PeerState {
  connections: { [key: string]: MyDataConnection };
  loading: boolean;
}

export async function getStream () {
  if (!GameModule.player) {
    router.replace('/')
  }
  let stream = GameModule.player && GameModule.player.stream
  if (!stream) {
    stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true })
    GameModule.setPlayerStream({ playerId: GameModule.playerId, stream: stream })
  }
  return stream
}

export function setListeners (conn) {
  conn.on('data', (data) => {
    console.log('data', data)
  })

  conn.on('close', () => {
    console.log('close')
  })

  conn.on('error', (err) => {
    console.error(err)
  })
}

@Module({ name: 'peer' })
export class PeerModuleClass extends VuexModule implements PeerState {
  connections = {}
  loading = true

  constructor (module) {
    super(module)
    $peer.on('open', this.onOpen)
    $peer.on('close', () => {
      console.log('close')
    })
    $peer.on('disconnected', () => {
      console.log('dis')
      // location.reload()
    })
    $peer.on('connection', this.onConnection)
    $peer.on('call', this.onCall)
    $peer.socket.on('message', this.onMessage)
  }

  @Mutation
  onOpen (id: string) {
    this.loading = false
    GameModule.setId(id)
  }

  @Mutation
  onConnection (conn: MyDataConnection) {
    console.log('conn IN', conn)
    this.connections[conn.connectionId] = conn
    GameModule.setConnection(conn.peer, conn.connectionId)
    setListeners(conn)
  }

  @Mutation
  onMessage (msg: {type: string; payload: any}) {
    switch (msg.type) {
      case 'ROOM': {
        const playersMap = GameModule.players.reduce((a, player) => {
          a[player.id] = player
          return a
        }, {})
        const players = msg.payload.players as Player[]
        GameModule.setPlayers(players.map(player => playersMap[player.id] || player))
        GameModule.setWords(msg.payload.words)
        GameModule.setActive(msg.payload.activePlayerId)
        GameModule.setPairs(msg.payload.pairs)
        console.log('players', GameModule.players)
        console.log('roomId', msg.payload.id)
        console.log('words', GameModule.words)
        console.log('active', GameModule.activePlayer)
        // console.log('pairs', GameModule.pairs)
        break
      }
      case 'READY':
        this.call()
        break
      case 'START':
        router.replace('game')
        break
      case 'END':
        router.replace('board')
        break
      case 'NEXT':
        router.replace('board')
        break
      default:
        break
    }
  }

  @Mutation
  async onCall (call) {
    const stream = await getStream()
    console.log('answer', call, stream)
    call.answer(stream)
    call.on('stream', (remoteStream) => {
      GameModule.setPlayerStream({ playerId: call.peer, stream: remoteStream })
      // this.callAll()
    })
  }

  @Mutation
  async call () {
    console.log('call')
    const stream = await getStream()
    GameModule.players.forEach(player => {
      if (player.id !== GameModule.playerId && !player.stream) {
        const call = $peer.call(player.id, stream)
        call.on('stream', (remoteStream) => {
          GameModule.setPlayerStream({ playerId: player.id, stream: remoteStream })
        })
      }
    })
  }

  @Mutation
  connect (id) {
    const conn = $peer.connect(id, {
      label: 'user',
      metadata: {
        name: 'userName'
      },
      serialization: 'json'
    }) as MyDataConnection

    // Outgoing connection listener
    conn.on('open', () => {
      conn.send('hi!')
      console.log('conn out', conn)
      this.connections[conn.connectionId] = conn
      GameModule.setConnection(id, conn.connectionId)
      setListeners(conn)
    })
  }

  @Action
  sendMessage (msg: {type: string; payload?: any}) {
    $peer.socket.send(msg)
  }

  @Action({ commit: 'call' })
  ready () {
    this.sendMessage({ type: 'READY' })
  }
}
